 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"artist.artwork.index":"artist.artwork.index","artist.artwork.test~search.index":"artist.artwork.test~search.index","artist.artwork.test":"artist.artwork.test","artist.single":"artist.single","artists.index":"artists.index","cancellation":"cancellation","cart":"cart","checkout":"checkout","artist.artwork":"artist.artwork","search.index":"search.index","profile.receipts":"profile.receipts","galleries":"galleries","galleries.single":"galleries.single","giftcard":"giftcard","giftcard.checkout":"giftcard.checkout","news":"news","news.single":"news.single","newsletter":"newsletter","pages":"pages","profile.account~signup":"profile.account~signup","profile.account":"profile.account","signup":"signup","profile.artworks":"profile.artworks","profile.artworks.edit":"profile.artworks.edit","profile.favorites":"profile.favorites","profile.practical":"profile.practical","profile.sales":"profile.sales"}[chunkId]||chunkId) + "." + {"artist.artwork.index":"bf411933","artist.artwork.test~search.index":"220022a2","artist.artwork.test":"d17c3c17","artist.single":"b0b44e1c","artists.index":"5e9c9558","cancellation":"80910a06","cart":"923e160f","checkout":"66dde8ce","chunk-28b74180":"34ec6573","artist.artwork":"63ba24b6","chunk-2d0f09e1":"fbb60c7e","chunk-2d2134eb":"0e1b9f39","chunk-2d21ad29":"c7ebfd6e","chunk-7bb1e555":"020b30ab","chunk-fbec784c":"448af1e7","search.index":"1644ffaf","profile.receipts":"0d128843","galleries":"c95c7fc8","galleries.single":"16932f88","giftcard":"30be4cd7","giftcard.checkout":"704dc0cf","news":"b5a73a6a","news.single":"c28f7ba3","newsletter":"a999e0be","pages":"370e3fe9","profile.account~signup":"fe6092a7","chunk-28ecd6af":"200531a3","profile.account":"afe2d8d9","signup":"1c18c17a","profile.artworks":"9dd91d3d","profile.artworks.edit":"11244f41","profile.favorites":"aceaa0b9","profile.practical":"fddc86ec","profile.sales":"306bec97","chunk-04f32a63":"3b66f2fa","chunk-1c6cdd8c":"2f764dad","chunk-1cc1ceb7":"fb429751","chunk-d4f1eff8":"9f634789","chunk-4f0bd3a4":"c198060b","chunk-700c0680":"7bd991a6","chunk-d00bfcfc":"5d7bf7e2","chunk-00108a32":"75ec4f46","chunk-2d20efc0":"92432b18","chunk-9832ab0c":"c7f76bfb","chunk-238e2e79":"4f3ae2b6","chunk-2d0c0a43":"54f407e8","chunk-2d216b78":"7f28d0dd","chunk-633f4282":"e75f527f","chunk-2d0c5b69":"30bdf8bb","chunk-62806c38":"726cdffb","chunk-69a5844e":"dda80479","chunk-2d0cebac":"b44fae2e","chunk-433115f7":"cc23e654","chunk-4ade1594":"42401dac","chunk-0bfc2728":"4843cba9","chunk-2d0b5e32":"0294af46","chunk-68396243":"4539f462","chunk-12e75968":"9e34fa54","chunk-2d0aa810":"7c1d6695","chunk-2d0db05c":"37b44f13","chunk-2d0e1995":"a7cf5897","chunk-2d21dca0":"b026aa79","chunk-2d22897b":"a27a64c1","chunk-4a5f46a6":"c14ec881","chunk-12891ad8":"e2bebf15"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"artist.artwork.index":1,"artist.artwork.test~search.index":1,"artist.artwork.test":1,"artists.index":1,"cancellation":1,"chunk-28b74180":1,"artist.artwork":1,"chunk-7bb1e555":1,"chunk-fbec784c":1,"search.index":1,"profile.receipts":1,"galleries":1,"galleries.single":1,"giftcard":1,"news":1,"newsletter":1,"pages":1,"profile.account~signup":1,"chunk-28ecd6af":1,"profile.account":1,"profile.artworks":1,"profile.artworks.edit":1,"profile.favorites":1,"profile.practical":1,"profile.sales":1,"chunk-04f32a63":1,"chunk-1c6cdd8c":1,"chunk-1cc1ceb7":1,"chunk-d4f1eff8":1,"chunk-4f0bd3a4":1,"chunk-700c0680":1,"chunk-d00bfcfc":1,"chunk-00108a32":1,"chunk-9832ab0c":1,"chunk-238e2e79":1,"chunk-633f4282":1,"chunk-62806c38":1,"chunk-69a5844e":1,"chunk-433115f7":1,"chunk-4ade1594":1,"chunk-0bfc2728":1,"chunk-68396243":1,"chunk-12e75968":1,"chunk-12891ad8":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"artist.artwork.index":"artist.artwork.index","artist.artwork.test~search.index":"artist.artwork.test~search.index","artist.artwork.test":"artist.artwork.test","artist.single":"artist.single","artists.index":"artists.index","cancellation":"cancellation","cart":"cart","checkout":"checkout","artist.artwork":"artist.artwork","search.index":"search.index","profile.receipts":"profile.receipts","galleries":"galleries","galleries.single":"galleries.single","giftcard":"giftcard","giftcard.checkout":"giftcard.checkout","news":"news","news.single":"news.single","newsletter":"newsletter","pages":"pages","profile.account~signup":"profile.account~signup","profile.account":"profile.account","signup":"signup","profile.artworks":"profile.artworks","profile.artworks.edit":"profile.artworks.edit","profile.favorites":"profile.favorites","profile.practical":"profile.practical","profile.sales":"profile.sales"}[chunkId]||chunkId) + "." + {"artist.artwork.index":"7a256b29","artist.artwork.test~search.index":"277e14ff","artist.artwork.test":"33068aff","artist.single":"31d6cfe0","artists.index":"0031c801","cancellation":"13e54cfd","cart":"31d6cfe0","checkout":"31d6cfe0","chunk-28b74180":"93e0ad48","artist.artwork":"3af14421","chunk-2d0f09e1":"31d6cfe0","chunk-2d2134eb":"31d6cfe0","chunk-2d21ad29":"31d6cfe0","chunk-7bb1e555":"c6ce1389","chunk-fbec784c":"11099f3b","search.index":"07a58115","profile.receipts":"e88e2424","galleries":"ad1a29de","galleries.single":"19328c62","giftcard":"587fa08f","giftcard.checkout":"31d6cfe0","news":"30483b43","news.single":"31d6cfe0","newsletter":"c988d950","pages":"e8154cd7","profile.account~signup":"8c45b93b","chunk-28ecd6af":"9ceafa09","profile.account":"03e8f8dc","signup":"31d6cfe0","profile.artworks":"8ffd5148","profile.artworks.edit":"46cf7fd9","profile.favorites":"e5baa9e4","profile.practical":"fda2e0dd","profile.sales":"e5baa9e4","chunk-04f32a63":"35c44496","chunk-1c6cdd8c":"81a66f22","chunk-1cc1ceb7":"b09157e0","chunk-d4f1eff8":"f1182a12","chunk-4f0bd3a4":"ef5d01d6","chunk-700c0680":"d0624a57","chunk-d00bfcfc":"b73969d8","chunk-00108a32":"687e5c53","chunk-2d20efc0":"31d6cfe0","chunk-9832ab0c":"e07a726c","chunk-238e2e79":"55547ee3","chunk-2d0c0a43":"31d6cfe0","chunk-2d216b78":"31d6cfe0","chunk-633f4282":"9bcef23c","chunk-2d0c5b69":"31d6cfe0","chunk-62806c38":"17a89de4","chunk-69a5844e":"746a1ac5","chunk-2d0cebac":"31d6cfe0","chunk-433115f7":"b36e54b7","chunk-4ade1594":"b6288540","chunk-0bfc2728":"98f83fb2","chunk-2d0b5e32":"31d6cfe0","chunk-68396243":"4065bee3","chunk-12e75968":"dc01f7a6","chunk-2d0aa810":"31d6cfe0","chunk-2d0db05c":"31d6cfe0","chunk-2d0e1995":"31d6cfe0","chunk-2d21dca0":"31d6cfe0","chunk-2d22897b":"31d6cfe0","chunk-4a5f46a6":"31d6cfe0","chunk-12891ad8":"d6a0d764"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
